import "./SinglePost.css";
import { useState } from "react";
import { useEffect, useContext } from "react";
import axiosInstance from '../../config';
import { useNavigate, useParams } from 'react-router-dom';
import Progress from "../../components/Progress/Progress";
import SinglePostPage from "./SinglePostPage";
import Topbar from "../../components/topbar/Topbar";
import Bottom from "../../components/Bottom/Bottom";

export default function Post() {
  const Navigate = useNavigate();
  const postId = useParams().postid;
  const [isfetching, setisfetching] = useState(true);
  const [post, setpost] = useState({});

  const fetchpost = async () => {
    try {
      const response = await axiosInstance.get('/api/posts/findpost/' + postId);
      setpost(response.data.post);
      setisfetching(false);
    } catch (error) {
      Navigate("*");
      console.log(error);
    }
  }
  useEffect(() => {
    fetchpost();
  }, [])

  return (
    <>
      <Topbar />
      <div className="singlepostpage">
        <div className="singlepost">
          {isfetching ? <Progress /> : <SinglePostPage post={post} />}
        </div>
      </div>
      <div className="copyright" style={{ 'backgroundColor': '#dadada' }}>
        <p style={{ 'textAlign': 'center', opacity: '0.6' }}>Copyright ©2022-Alok.info | All rights reserved</p>
      </div>
      <Bottom />
    </>
  );
}